import { grupo_usuario } from '@/shared/dtos/grupo_usuarios/grupo_usuario';
import { Usuario } from '../usuario';

export class grupo_usuarioAllDto extends grupo_usuario {
    public usuarios !: Usuario[];
 } 
